import { connect } from 'react-redux';
import withStore from './withStore';

function connectWithStore(mapStateToProps, mapDispatchToProps, mergeProps, options) {
  return (WrappedComponent) => {
    const ConnectedComponent = connect(mapStateToProps,
      mapDispatchToProps,
      mergeProps,
      options)(WrappedComponent);
    return withStore(ConnectedComponent);
  };
}

export default connectWithStore;
